export default __webpack_public_path__ + "static/media/navbar-logo.d75ee0b5.png";